import * as React from 'react';
import { Redirect, Route, RouteProps } from 'react-router';
import { Page } from '../common/enums/Page';
import pageRequiredActionCodes from '../common/pageRequiredActionCodes';
import { ActionCode } from '../common/enums';
import { AuthorizationType } from '../store/AuthenticationStore';

interface RestrictedToLoggedUserRouteProps extends RouteProps {
  isAuthenticated: boolean;
  userHasActions: (requireActionCodes: ActionCode[], authorizationType: AuthorizationType) => boolean;
}

export default class ProtectedRoute extends React.Component<RestrictedToLoggedUserRouteProps> {
  render() {
    let redirectPath = '';

    const { isAuthenticated } = this.props;
    const findRoute = Object.keys(pageRequiredActionCodes);
    const found = findRoute.find((key) => this.props.location!.pathname.startsWith(key));

    let isAuthorized = isAuthenticated;
    if (found) {
      const codeFoundForUser = this.props.userHasActions(pageRequiredActionCodes[found], 'atLeastOne');
      isAuthorized = isAuthorized && codeFoundForUser;
    }
    if (!isAuthenticated) {
      redirectPath = Page.Login;
    } else if (!isAuthorized) {
      redirectPath = Page.Unauthorized;
    }

    if (redirectPath) {
      const renderComponent = () => <Redirect to={{ pathname: redirectPath }} />;
      // Override render method from props.
      return <Route {...this.props} component={renderComponent} render={undefined} />;
    }
    return <Route {...this.props} />;
  }
}
